const mobileUserTypes = ['staff', 'resident', 'family', 'member', 'neighbor', 'driver', 'homeowner']

module.exports = mobileUserTypes
